var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "url(#paint0_linear_3708_531)",
    stroke: "url(#paint1_linear_3708_531)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3708_531)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.15385,
    fill: "#8B5D43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6027 8.47017C11.7598 8.12957 12.2439 8.12957 12.401 8.47017L13.139 10.0701C13.203 10.2089 13.3346 10.3045 13.4864 10.3225L15.236 10.5299C15.6085 10.5741 15.7581 11.0345 15.4827 11.2891L14.1891 12.4854C14.0769 12.5892 14.0266 12.7438 14.0564 12.8938L14.3998 14.6219C14.4729 14.9898 14.0813 15.2743 13.754 15.0911L12.2166 14.2305C12.0832 14.1558 11.9206 14.1558 11.7872 14.2305L10.2497 15.0911C9.92245 15.2743 9.53082 14.9898 9.60392 14.6219L9.94729 12.8938C9.97708 12.7438 9.92683 12.5892 9.8146 12.4854L8.52105 11.2891C8.24566 11.0345 8.39525 10.5741 8.76774 10.5299L10.5174 10.3225C10.6692 10.3045 10.8007 10.2089 10.8648 10.0701L11.6027 8.47017Z",
    fill: "url(#paint2_linear_3708_531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3708_531",
    x: 5.84619,
    y: 5.84619,
    width: 12.3076,
    height: 12.3077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420833 0 0 0 0 0.213095 0 0 0 0 0.103455 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3708_531"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.991667 0 0 0 0 0.699296 0 0 0 0 0.545417 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3708_531",
    result: "effect2_innerShadow_3708_531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_531",
    x1: 6.65228,
    y1: 3.36691,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B5D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_531",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B18362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#764F33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3708_531",
    x1: 7.60587,
    y1: 7.60475,
    x2: 16.3971,
    y2: 16.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9815B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankThree);
export default __webpack_public_path__ + "static/media/RankThree.16bfdfdbdf5a71fc7fd27ab3836dcd53.svg";
export { ForwardRef as ReactComponent };